import client from "@/lib/api";

export const SUPPORTED_CHAINS = { 1: "Ethereum", 56: "BNB Chain", 8453: "Base" };

// EIP-6963 multi-wallet discovery with a legacy window.ethereum fallback.
export function discoverWallets() {
  return new Promise((resolve) => {
    const found = new Map();
    const onAnnounce = (e) => found.set(e.detail.info.uuid, e.detail);
    window.addEventListener("eip6963:announceProvider", onAnnounce);
    window.dispatchEvent(new Event("eip6963:requestProvider"));
    setTimeout(() => {
      window.removeEventListener("eip6963:announceProvider", onAnnounce);
      if (!found.size && window.ethereum) {
        found.set("legacy", { info: { uuid: "legacy", name: "Browser wallet", icon: "" }, provider: window.ethereum });
      }
      resolve([...found.values()]);
    }, 400);
  });
}

async function ensureSupportedChain(provider) {
  let chainId = parseInt(await provider.request({ method: "eth_chainId" }), 16);
  if (SUPPORTED_CHAINS[chainId]) return chainId;
  await provider.request({ method: "wallet_switchEthereumChain", params: [{ chainId: "0x1" }] });
  chainId = parseInt(await provider.request({ method: "eth_chainId" }), 16);
  if (!SUPPORTED_CHAINS[chainId]) throw new Error("Please switch your wallet to Ethereum, BNB Chain or Base.");
  return chainId;
}

// Asks the server for a SIWE message, has the wallet sign it (no transaction, no gas).
export async function signWalletChallenge(provider, purpose) {
  const accounts = await provider.request({ method: "eth_requestAccounts" });
  if (!accounts?.length) throw new Error("No wallet account selected.");
  const chainId = await ensureSupportedChain(provider);
  const { data } = await client.post("/auth/wallet/challenge", { address: accounts[0], chain_id: chainId, purpose });
  const signature = await provider.request({ method: "personal_sign", params: [data.message, accounts[0]] });
  return { nonce: data.nonce, signature };
}

export function walletErrorMessage(e) {
  if (e?.code === 4001) return "You cancelled the request in your wallet.";
  if (e?.code === 4902) return "Your wallet doesn't have this network yet.";
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  return e?.message || "Wallet request failed. Please try again.";
}

export const maskAddress = (a) => (a && a.length > 12 ? `${a.slice(0, 6)}…${a.slice(-4)}` : a || "");
